import { APIProvider, Map } from '@vis.gl/react-google-maps';
import { MapOutline } from 'mdi-material-ui';
import { MuiButton } from '@/components/button/MuiButton';
import { service_ResponseForNonMemberPortalOfficeListing } from '@/init/swagger';
import { PublicStationMarker } from './PublicStationMarker';
import { useLogic } from './logic';

type Props = {
  listings: service_ResponseForNonMemberPortalOfficeListing[];
  handleToggleMap: () => void;
  hoveredMarkerListingId?: number | null;
  onMarkerClick?: (listingId: number) => void;
};

export const PublicStationMap: React.FC<Props> = ({
  listings,
  handleToggleMap,
  hoveredMarkerListingId,
  onMarkerClick,
}) => {
  const { cameraProps, handleCameraChange } = useLogic({
    listings,
  });

  return (
    <APIProvider apiKey={process.env.NEXT_PUBLIC_MAPS_API_KEY as string}>
      <MuiButton
        startIcon={<MapOutline />}
        onClick={handleToggleMap}
        variant="contained"
        sx={{
          m: 0,
          maxHeight: 32,
          display: 'none',
          '@media (max-width: 800px)': {
            display: 'flex',
            margin: '0 auto',
            my: 2,
          },
        }}
      >
        Map表示
      </MuiButton>
      <Map
        {...cameraProps}
        onCameraChanged={handleCameraChange}
        mapId={'station-map'}
      >
        {listings.map((listing) => (
          <PublicStationMarker
            key={listing.id}
            listing={listing}
            hoveredMarkerListingId={hoveredMarkerListingId}
            onMarkerClick={onMarkerClick}
          />
        ))}
      </Map>
    </APIProvider>
  );
};
